<template>
    <div>
        <pop-form class="form-box" v-if="show" width="580px" body-max-height="500px">
            <template slot="title">选择员工</template>
            <div class="body-box">
                <!--职位筛选-->
                <div class="category-box">
                    <div class="left-box">
                        <i class="el-icon-arrow-left" @click="leftMove"></i>
                    </div>
                    <div class="center-box">
                        <div ref="content" class="content">
                            <el-radio-group v-model="form.role_id" size="medium">
                                <el-radio-button v-for="val in roleData" :label="val.role_id" :key="val.role_id">
                                    {{val.role_name}}
                                </el-radio-button>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="right-box">
                        <i class="el-icon-arrow-right" @click="rightMove"></i>
                    </div>
                </div>
                <!--搜索-->
                <div class="search-box flex">
                    <i class="input_icon el-icon-search"></i>
                    <input class="flex-1" type="text" v-model="search" placeholder="工号/姓名" @input="searchChange" />
                </div>
                <!--员工列表-->
                <div class="list-data-box">
                    <div class="list-box">
                        <div class="item" v-for="(val, k) in staffListData" :key="k">
                            <div class="check-box" :class="{active: isSelected(val.id), disabled: val.rew_id && val.rew_id != rewId}"
                                 @click="selected(val)">
                                {{val.work_id}} {{val.name}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template slot="foot">
                <div class="foot-box">
                    <div class="check-all-box">
                        <el-checkbox v-model="checkAll">全选</el-checkbox>
                    </div>
                    <el-button size="medium" @click="close">&nbsp;&nbsp;取消&nbsp;&nbsp;</el-button>
                    <el-button size="medium" type="primary" @click="submit">&nbsp;&nbsp;确定&nbsp;&nbsp;</el-button>
                </div>
            </template>
        </pop-form>
    </div>
</template>

<script>
    import PopForm from "@/model/PopForm";
    import obj from "@/js/obj";
    export default {
        name: "StaffRewardOptionStaffSelect",
        components: {PopForm},
        model: {
            prop: "show",
            event: "showChange"
        },
        props: {
            show: {
                type: Boolean,
                default: true
            },
            rewId: {
                type: String,
                default: ""
            },
            selectedStaff: {
                type: Array,
                default: () => ([])
            },
            proType: {
                type: Number,
                default: 0
            }
        },
        data: () => ({
            transX: 0,

            roleData: [],
            form: {
                role_id: 0,
            },

            checkAll: false,
            search: "",
            activeId: ["2"],
            staffListData: [
                // {
                //     id: "",
                //     name: "不选择",
                //     work_id: "",
                //     rew_id: ""
                // }
            ],
            staffOriginData: [],
        }),
        mounted: function () {

        },
        methods: {
            //初始化
            init: function () {
                this.getRoleList();
                this.getStaffListData();

                let activeArr = [];
                this.selectedStaff.forEach( val => {
                    activeArr.push(val.id);
                });
                this.activeId = activeArr;
            },
            //左右移动角色
            animateMove: function (width, time) {
                let t = 0;
                let ts = 1;
                let speed = width * (ts / time);
                let contentDom = this.$refs.content;
                let maxWidth = contentDom.parentElement.offsetWidth;
                let clientWidth = contentDom.offsetWidth;

                let timer = setInterval( () => {
                    this.transX += speed;

                    if(width > 0 && this.transX >= 0) {
                        this.transX = 0;
                    }
                    if(width < 0 && maxWidth - clientWidth >= this.transX) {
                        this.transX = maxWidth - clientWidth;
                    }

                    contentDom.style.transform = "translateX("+this.transX+"px)";
                    t += ts;
                    if( t >= time) clearInterval(timer);
                }, ts);
            },
            rightMove: function () {
                this.animateMove(100, 50);
            },
            leftMove: function () {
                this.animateMove(-100, 50);
            },

            //关闭
            close: function () {
                this.$emit("showChange", false);
            },

            //提交
            submit: function () {
                let result = [];
                this.staffListData.forEach(val => {
                    if(obj.inArray(val.id, this.activeId)) {
                        result.push({
                            id: val.id,
                            name: val.name,
                            work_id: val.work_id
                        });
                    }
                });
                this.$emit("selected", result);
                this.close();
            },

            //搜索值改变
            searchChange: function () {
                let search = this.search;
                let listData = [];
                if(search === "") {
                    listData = this.staffOriginData;
                }else {
                    this.staffOriginData.forEach((val, key) => {
                        if (val.work_id.indexOf(search) > -1) {
                            listData.push(val);
                        } else if (val.name.indexOf(search) > -1) {
                            listData.push(val);
                        }
                    });
                }
                this.staffListData = listData;
            },

            //获取职位
            getRoleList: function () {
                obj.postData("store_role/get_role_list", {}, res => {
                    if(res.errcode === 0) {
                        let listData =[];
                        res.data.forEach( val => {
                            if(!obj.isEmpty(val.is_system)) {
                                listData.push(val);
                            }else{
                                listData.unshift(val);
                            }
                        });
                        listData.unshift({
                            role_id: 0,
                            role_name: "所有"
                        });
                        this.roleData = listData;
                    }else
                        obj.message.error(res.errdesc);
                });
            },

            //获取员工列表
            getStaffListData: function () {
                let postData = {
                    role_id: this.form.role_id,
                    pro_type: this.proType,
                    limit: 10000,
                    offset: 0,
                };
                obj.postData("store_reward/get_staff_list", postData, res => {
                    if(res.errcode === 0) {
                        this.staffListData = this.staffOriginData = res.data.listData;
                    }else{
                        obj.message.error(res.errdesc);
                    }
                });
            },

            //选择员工
            selected: function (item) {
                if(obj.isEmpty(item.id)) {
                    this.activeId = [];
                } else if(obj.inArray(item.id, this.activeId)) {
                    for (let i = 0; i < this.activeId.length; i++) {
                        if(this.activeId[i] === item.id) {
                            this.activeId.splice(i, 1);
                            break;
                        }
                    }
                } else if(!item.rew_id || item.rew_id == this.rewId) {
                    this.activeId.push(item.id);

                } else if(item.rew_id && item.rew_id != this.rewId){
                    obj.message.error("收银员"+item.name+"已经适配了方案"+item.rew_name);
                }
            },
            //是否被选中
            isSelected: function (id) {
                if(obj.isEmpty(id) && obj.isEmpty(this.activeId))
                    return true;
                else
                    return obj.inArray(id, this.activeId);
            }
        },
        watch: {
            show: function (val) {
                if(val) {
                    this.init();
                }
            },
            "form.role_id": function () {
                this.getStaffListData();
            },
            checkAll: function (val) {
                if(val) {
                    this.staffListData.forEach(staff => {
                        if(!obj.inArray(staff.id, this.activeId) && (!staff.rew_id || staff.rew_id == this.rewId)) {
                            this.activeId.push(staff.id);
                        }
                    });
                }else{
                    this.activeId = [];
                }
            },
            activeId: function (val) {
                if(obj.isEmpty(val))
                    this.checkAll = false;
            }
        }
    }
</script>

<style scoped>
    .foot-box{
        padding: 0 20px 10px;
        text-align: right;
    }
    .foot-box .check-all-box{
        float: left;
    }
    .category-box{
        margin-top: 6px;
        display: flex;
        flex-flow: row nowrap;
    }
    .category-box>.left-box{
        width: 30px;
        text-align: center;
        cursor: pointer;
        line-height: 36px;
    }
    .category-box>.right-box{
        width: 30px;
        text-align: center;
        cursor: pointer;
        line-height: 36px;
    }
    .category-box>.center-box{
        flex: 1;
        overflow: hidden;
    }
    .category-box>.center-box>.content{
        /*width: 1000px;*/
        /*background-color: red;*/
    }

    .search-box{
        margin: 10px 10px 0px;
        border-bottom: 1px solid #e5e5e5;
    }
    .search-box .input_icon{
        padding: 0px 10px;
        line-height: 40px;
    }
    .search-box>input{
        border: none;
    }
    .list-data-box{
        height: 282px;
    }
    .list-box{
        padding: 16px 10px;
        display: flex;
        flex-flow: row wrap;
        max-height: 250px;
        overflow: auto;
    }
    .list-box>.item{
        width: 50%;
    }
    .item .check-box{
        margin: 8px 10px;
        line-height: 45px;
        text-align: center;
        border: 1px solid #e5e5e5;
        cursor: pointer;
    }
    .item .check-box.active{
        border-color: #6cb1e1;
        background-color: #f0f7fc;
    }
    .item .check-box.disabled{
        border-color: #f1f1f1;
        background-color: #f7f7f7;
    }
</style>
